<template>
  <div class="ytree">
    <div
      v-if="treeName"
      class="ytree_title"
      @click="getTitle"
      @mouseover="isMore = true"
      @mouseleave="isMore = false"
    >
      <div
        class="ytree_title-left"
        :class="clickTitle == treeName ? 'click_title' : ''"
      >
        <i class="ytree_title-left_icon iconfont" :class="treeIcon"></i>
        <span class="ytree_title-left_name">{{ treeName }}</span>
      </div>
      <div class="ytree_title-right" v-show="isMore">
        <span class="ytree_title-right-expand" @click="doExpandTree">
          <i
            class="el-icon-s-unfold eiconfont"
            v-if="!expandTree"
            title="全部折叠"
          ></i>
          <i
            class="el-icon-s-fold eiconfont"
            v-if="expandTree"
            title="全部展开"
          ></i>
        </span>
        <span class="ytree_title-right-search" @click="doSearch">
          <i class="ytree_title-right-search_icon iconfont icon-Search"></i>
        </span>

        <el-popover
          placement="bottom-end"
          trigger="click"
          width="120"
          :append-to-body="true"
          popper-class="operation_popover"
          ref="operatePopoverRef"
          @hide="resetAdd"
        >
          <div class="operation_popover_content">
            <div
              class="operation_popover_content-first"
              v-if="operationPopoverFirst == '1'"
            >
              <div
                class="operation_popover_content-first_operatelist"
                @click="doAdd"
                v-if="isAddTree"
              >
                <i
                  class="operation_popover_content-first_operatelist_icon econfont el-icon-plus"
                ></i>
                <span class="operation_popover_content-first_operatelist_name"
                  >新增</span
                >
              </div>
              <el-divider v-if="isAddTree && isShowReport"></el-divider>

              <div
                class="operation_popover_content-first_check"
                v-if="isShowReport"
              >
                <!-- 显示到报表 -->
                <!-- <el-switch v-model="showReport" @change="changeShowReport">
                </el-switch> -->
                <el-radio-group v-model="showReport" @change="changeShowReport">
                  <el-radio :label="true">显示到报表</el-radio>
                  <el-radio :label="false">不显示到报表</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div
              class="operation_popover_content-second"
              v-if="operationPopoverFirst == '2'"
            >
              <div class="operation_popover_content-second_title">
                <i class="el-icon-arrow-left eiconfont" @click="doBack"></i>
                <div class="operation_popover_content-second_title_name">
                  {{ "新建" + treeInfo.name }}
                </div>
                <i
                  class="el-icon-close eiconfont"
                  @click="closeOperatePopover"
                ></i>
              </div>
              <div class="operation_popover_content-second-input">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                  <el-form-item prop="addName">
                    <el-input
                      v-model="ruleForm.addName"
                      placeholder="请输入内容"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <el-button type="primary" @click="confirmAdd('ruleForm')"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
          <i
            class="ytree_title-right-add el-icon-more eiconfont"
            slot="reference"
          ></i>
        </el-popover>
      </div>
      <div class="ytree_title-right-search_inputbox" v-if="isSearch">
        <el-select
          class="ytree_title-right-search_inputbox-input"
          v-model="filterText"
          filterable
          remote
          placeholder="请输入关键词搜索"
          :remote-method="remoteMethod"
          :loading="loading"
          @change="getCurrentNode"
        >
          <el-option-group
            v-for="group in options"
            :key="group.label"
            :label="group.label"
          >
            <el-option
              v-for="item in group.options"
              :key="item[treeNodeKey]"
              :label="item[defaultProps.label]"
              :value="item[treeNodeKey]"
            >
              <i v-if="item.isReport == 1" class="el-icon-document"></i>
              <i v-if="item.isReport == 2" class="el-icon-folder-opened"></i>
              <span>
                {{ item[defaultProps.label] }}
              </span>
            </el-option>
          </el-option-group>
          <!-- <el-option
                v-for="item in options"
                :key="item.id"
                :label="item[defaultProps.label]"
                :value="item.id"
              >
                <i v-if="item.isReport == 1" class="el-icon-document"></i>
                <i v-if="item.isReport == 2" class="el-icon-folder-opened"></i>
                <span>
                  {{ item[defaultProps.label] }}
                </span>
              </el-option> -->
          <span></span>
        </el-select>
        <!-- <el-input
           class="ytree_title-right-search_inputbox-input"
              v-model="filterText"
              size="mini"
              placeholder="请输入关键字搜索"
              suffix-icon="el-icon-search"
              clearable
              @clear="emptyFilterText"
            ></el-input> -->
        <span
          class="ytree_title-right-search_inputbox-cancel"
          @click="cancelSearch"
          >取消</span
        >
      </div>
    </div>
    <el-tree
      ref="tree"
      :props="defaultProps"
      :class="treeDraggable == true ? 'ytree-draggable' : ''"
      :node-key="treeNodeKey"
      :treeInfo="treeInfo"
      :data="treeData"
      :empty-text="treeEmptyText"
      :default-expand-all="treeDefaultExpandAll"
      :default-expanded-keys="treeDefaultExpandedKeys"
      :expand-on-click-node="treeExpandOnClickNode"
      :icon-class="treeIconClass"
      :highlight-current="treeHighlightCurrent"
      :show-checkbox="treeShowCheckbox"
      :filter-node-method="filterNode"
      :draggable="treeDraggable"
      :allow-drag="treeAllowDrag"
      :allow-drop="treeAllowDrop"
      :current-node-key="currentNodeKey"
      :auto-expand-parent="treeAutoExpandParent"
      @node-drag-start="handleDragStart"
      @node-drag-enter="handleDragEnter"
      @node-drag-leave="handleDragLeave"
      @node-drag-over="handleDragOver"
      @node-drag-end="handleDragEnd"
      @node-drop="handleDrop"
      @node-click="nodeClick"
    >
      <span
        class="ytree_node"
        slot-scope="{ node, data }"
        v-on:mouseover="mouseover(data)"
        v-on:mouseout="mouseout(data)"
      >
        <span class="ytree_node-left">
          <i
            class="ytree_node-icon"
            :class="data.isReport == 2 ? categoryIcon : reportIcon"
          ></i>
          <span class="ytree_lable" :title="node.label">{{ node.label }}</span>
        </span>

        <el-popover
          placement="bottom-end"
          width="120"
          trigger="click"
          :append-to-body="true"
          ref="treeOperateRef"
          popper-class="tree_popover"
          @hide="resetOperate"
        >
          <div class="ytree_popover">
            <div class="ytree_popover-first" v-show="ytreePopoverFirst == '1'">
              <div
                class="ytree_popover-first_operate"
                v-for="item in treeOperateList"
                :key="item.index"
                @click="doOperate(item, data)"
              >
                <i :class="item.icon" class="eiconfont"></i>
                <span class="ytree_popover-first_operate_name">{{
                  item.label
                }}</span>
              </div>
            </div>

            <div class="ytree_popover-second" v-show="ytreePopoverFirst == '2'">
              <div class="ytree_popover-second_title" @click="goBack">
                <i class="el-icon-arrow-left eiconfont"></i>
                <div class="ytree_popover-second_title_name">
                  {{ operateName + treeInfo.name }}
                </div>
                <i
                  class="el-icon-close eiconfont"
                  @click="closeTreeOperatePopover(data)"
                ></i>
              </div>
              <div class="ytree_popover-second-input">
                <el-form
                  :model="nodeRuleForm"
                  :rules="rules"
                  ref="nodeRuleForm"
                >
                  <el-form-item prop="addNodeName">
                    <el-input
                      v-model="nodeRuleForm.addNodeName"
                      placeholder="请输入内容"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <el-button
                  type="primary"
                  @click="confirmAddNode('nodeRuleForm', data)"
                  >确定</el-button
                >
              </div>
            </div>
            <div class="ytree_popover-second" v-show="ytreePopoverFirst == '3'">
              <div class="ytree_popover-second_title" @click="goBack">
                <i class="el-icon-arrow-left eiconfont"></i>
                <div class="ytree_popover-second_title_name">
                  {{ operateName }}
                </div>
                <i
                  class="el-icon-close eiconfont"
                  @click="closeTreeOperatePopover(data)"
                ></i>
              </div>
              <div class="ytree_popover-second-input">
                <div class="ytree_popover-second-input_content">
                  确定删除{{ data[defaultProps.label] }}吗？
                </div>

                <el-button type="primary" @click="confirmDelete(node, data)"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
          <i
            slot="reference"
            class="eiconfont el-icon-more"
            v-show="
              hoverTreeNode &&
                data[defaultProps.label].trim() != '默认分类' &&
                data[defaultProps.label].trim() != '未分类报表' &&
                data[defaultProps.label].trim() != '未发布' &&
                activeTreeNode == data[treeNodeKey] &&
                data.isReport != 1 &&
                treeOperateList &&
                treeOperateList.length > 0
            "
          ></i>
        </el-popover>
      </span>
    </el-tree>
  </div>
</template>
<script>
//参数说明
//treeIcon:树根节点icon
//categoryIcon:分类icon
// reportIcon:报表icon
//treeName: 树名
//treeNodeKey:每个树节点用来作为唯一标识的属性，整棵树应该是唯一的
//defaultProps: 树结构的配置
//isShowReport: 是否有显示到报表功能，默认为false
//isAddTree: 报表根节点是否有新增功能， 默认为true

//treeData:展示数据array
//treeEmptyText: 无数据时的展示内容
//treeInfo: 新增树的信息

//treeDefaultExpandAll: 是否默认展开所有树
//treeDefaultExpandedKeys:默认展开的节点的 key 的数组(array)
//treeExpandOnClickNode:是否在点击节点的时候展开或者收缩节点， 默认值为 true，如果为 false，则只有点箭头图标的时候才会展开或者收缩节点(boolean)

//treeIconClass:自定义树节点的图标(string)
//treeHighlightCurrent:是否高亮当前选中节点，这里默认值是true(boolean)
//treeShowCheckbox:节点是否可被选择(boolean)

//treeDraggable:树是否可拖拽
//allow-drag:判断节点能否被拖拽
//allow-drop:
//filterNode:
//事件
//addTreeData :新增树节点
//addNodeData: 新增节点
//deleteNodeData:删除节点数据
//node-click:节点被点击时的回调(共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点对应的 Node、节点组件本身。)

export default {
  name: "ytree",
  props: {
    clickTitle: {
      type: String,
      default: "",
    },
    treeIcon: {
      type: String,
      default: "",
    },
    categoryIcon: {
      type: String,
      default: "",
    },
    reportIcon: {
      type: String,
      default: "",
    },
    treeName: {
      type: String,
      default: "",
    },
    defaultProps: {
      type: Object,
      default() {
        return {
          children: "children",
          label: "label",
        };
      },
    },
    isAddTree: {
      type: Boolean,
      default: true,
    },
    isShowReport: {
      type: Boolean,
      default: false,
    },
    treeInfo: {
      type: Object,
      default() {
        return {
          name: "",
        };
      },
    },
    treeNodeKey: {
      type: String,
      default: "id",
    },
    treeData: {
      type: Array,
    },
    treeEmptyText: {
      type: String,
      default: "暂无数据",
    },
    treeDefaultExpandAll: {
      type: Boolean,
      default: false,
    },
    // treeDefaultExpandedKeys: {
    //   type: Array,
    // },
    treeExpandOnClickNode: {
      type: Boolean,
      default: false,
    },
    treeIconClass: {
      type: String,
    },
    treeHighlightCurrent: {
      type: Boolean,
      default: true,
    },
    treeShowCheckbox: {
      type: Boolean,
      default: false,
    },
    treeDraggable: {
      type: Boolean,
      default: false,
    },
    treeAllowDrag: {
      type: Function,
      default: () => {
        return true;
      },
    },
    treeAllowDrop: {
      type: Function,
      default: () => {
        return true;
      },
    },
    treeAutoExpandParent: {
      type: Boolean,
      default: true,
    },
    treeOperateList: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      isMore: false,
      expandTree: this.treeDefaultExpandAll, //是否全部展开或折叠
      isSearch: false, //是否显示搜索栏
      showReport: false, //显示到报表
      filterText: "", //过滤关键字
      currentNodeKey: null, //当前选中的节点
      treeDefaultExpandedKeys: [],

      options: [],
      loading: false,
      operationPopoverFirst: "1", //操作弹框显示第一页
      ruleForm: {
        addName: "", //新增
      },
      nodeRuleForm: {
        addNodeName: "", //子节点新增
      },

      rules: {
        addName: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        addNodeName: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
      },
      hoverTreeNode: false, //鼠标悬浮显示操作符
      activeTreeNode: "",
      ytreePopoverFirst: "1",
      ytreePopoverOperate: "",

      operateName: "",
    };
  },
  watch: {
    treeDefaultExpandAll: {
      handler(newVal) {
        return newVal;
      },
      deep: true, // 表示开启深度监听
    },
    // filterText(val) {
    //   this.$refs.tree.filter(val);
    // },
  },
  methods: {
    getTitle() {
      console.log("treeName", this.treeName);
      this.$emit("getTitle", this.treeName);
    },
    //全部展开或折叠
    doExpandTree() {
      console.log("treerefff", this.$refs.tree);
      this.expandTree = !this.expandTree;
      for (let i = 0; i < this.$refs.tree.store._getAllNodes().length; i++) {
        this.$refs.tree.store._getAllNodes()[i].expanded = this.expandTree;
      }
    },
    //搜索树
    doSearch() {
      this.isSearch = true;
    },
    cancelSearch() {
      this.isSearch = false;
      this.filterText = "";
    },
    remoteMethod(query) {
      console.log("所有的树数据", this.treeData);

      //搜索数据
      if (query !== "") {
        let searchData = this.treeToArray(this.treeData);

        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          console.log("所有的树平铺", searchData);
          //     this.loading = false;
          this.options = searchData.filter((item) => {
            return (
              item[this.defaultProps.label]
                .toLowerCase()
                .indexOf(query.toLowerCase()) > -1
            );
          });
          //给选项分类
          if (this.options.length > 0) {
            let reportCategoryOption = [];
            let reportOption = [];
            let otherOptions = [];
            this.options.forEach((item) => {
              if (item.isReport == 2) {
                reportCategoryOption.push(item);
              } else if (item.isReport == 1) {
                reportOption.push(item);
              } else {
                otherOptions.push(item);
              }
            });
            let options = [];
            if (reportOption.length > 0) {
              let report = {
                label: "报表",
                options: reportOption,
              };
              options.push(report);
            }
            if (reportCategoryOption.length > 0) {
              let reportCategory = {
                label: "报表分类",
                options: reportCategoryOption,
              };
              options.push(reportCategory);
            }
            if (otherOptions.length > 0) {
              let item = {
                label: "",
                options: otherOptions,
              };
              options.push(item);
            }

            this.options = options;
          }
          console.log("过滤后的树数据", this.options);
        }, 200);
      } else {
        this.options = [];
      }
    },
    getCurrentNode() {
      this.currentNodeKey = this.filterText;
      console.log("选中的节点", this.filterText, this.currentNodeKey);
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.currentNodeKey);
        this.treeDefaultExpandedKeys.push(this.currentNodeKey);
      });
      this.isSearch = false;
      this.filterText = "";
      const reportNodes = this.$refs.tree.store._getAllNodes();
      console.log("所有的jiedian", reportNodes);
      if (reportNodes.length > 0) {
        let current = null;
        let val = reportNodes.find(
          (v) => v.data[this.treeNodeKey] == this.currentNodeKey
        );
        if (val) {
          current = val;
          let data = current.data;
          let node = current;
          let c = null;
          this.nodeClick(data, node, c);
        }
      }
    },

    //树形结构平铺
    treeToArray(data, res = []) {
      data.forEach((item) => {
        let tree = {
          [this.defaultProps.label]: item[this.defaultProps.label],
          id: item.id,
          parentId: item.parentId,
          isReport: item.isReport,
        };
        tree[this.treeNodeKey] = item[this.treeNodeKey];
        res.push(tree);
        if (item.children && item.children.length > 0) {
          this.treeToArray(item.children, res);
        }
      });
      return res;
    },
    //点击x清空树节点
    emptyFilterText() {
      this.filterText = "";
    },
    //显示到报表
    changeShowReport() {
      const reportNodes = this.$refs.tree.store._getAllNodes();
      console.log("reportNodes11111", reportNodes);
      this.$nextTick(() => {
        for (let i = 0; i < reportNodes.length; i++) {
          // if(reportNodes[i].data.isReport==1){
          //   console.log('223333', reportNodes[i])
          //   reportNodes[i].expanded = this.showReport;
          //   this.treeDefaultExpandedKeys.push(reportNodes[i]);
          // }
          reportNodes[i].expanded = this.showReport;
        }
      });
      this.$emit("showReport", this.showReport);
    },
    confirmAdd(formName) {
      // const allNodes = this.$refs.tree.store._getAllNodes();
      // if(allNodes&&allNodes.length>0){
      //   let existName=allNodes.find(
      //     (v) => v.data[this.defaultProps.label] == this.ruleForm.addName
      //   );
      //   if(existName){
      //     this.$message.error('名称重复，请重新输入')
      //   }
      //   else{
      //     this.$nextTick(() => {
      //   this.$refs[formName].validate((valid) => {
      //     if (valid) {
      //       this.$emit("addTreeData", this.ruleForm.addName);
      //       this.closeOperatePopover();
      //     }
      //   });
      // });
      //   }
      // }

      this.$nextTick(() => {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$emit("addTreeData", this.ruleForm.addName);
            this.closeOperatePopover();
          }
        });
      });
    },
    //置空新增数据
    resetAdd() {
      this.operationPopoverFirst = "1";
      this.ruleForm.addName = "";
    },
    //关闭操作
    closeOperatePopover() {
      document.body.click();
      this.resetAdd();
    },
    doAdd() {
      this.operationPopoverFirst = "2";
    },
    doBack() {
      this.operationPopoverFirst = "1";
    },
    goBack() {
      this.ytreePopoverFirst = "1";
    },
    doOperate(item, data) {
      this.operateName = item.label;
      if (item.label == "新增") {
        this.ytreePopoverFirst = "2";
        this.ytreePopoverOperate = "新增";
      } else if (item.label == "编辑") {
        this.ytreePopoverOperate = "编辑";
        this.ytreePopoverFirst = "2";
        this.nodeRuleForm.addNodeName = data[this.defaultProps.label];
        console.log("新增你", this.nodeRuleForm.addNodeName);
      } else if (item.label == "删除") {
        //删除
        this.ytreePopoverFirst = "3";
      } else {
        this.ytreePopoverFirst = "1";
        this.$emit("doOtherOperate", data);
      }
    },
    confirmAddNode(formName, data) {
      console.log("树1117899", this.$refs.tree.store.currentNode.level);
      console.log("thisreffffff1111", formName, data);
      let level = this.$refs.tree.store.currentNode.level; //节点的层级,最多只能加5级
      if (level <= 4) {
        this.$nextTick(() => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if (this.ytreePopoverOperate == "新增") {
                this.$emit("addNodeData", this.nodeRuleForm.addNodeName, data);
              } else {
                this.$emit("editNodeData", this.nodeRuleForm.addNodeName, data);
              }
              this.closeTreeOperatePopover();
            }
          });
        });
      } else {
        this.$message.error("最多只能添加5层节点，当前节点已超出。");
      }
    },
    //删除节点
    confirmDelete(node, data) {
      this.$emit("deleteNodeData", node, data);
      this.closeTreeOperatePopover();
    },
    closeTreeOperatePopover(data) {
      document.body.click();
      this.$nextTick(() => {
        this.$refs.treeOperateRef.doClose();
      });

      this.resetOperate();
    },
    resetOperate() {
      this.ytreePopoverFirst = "1";
      this.nodeRuleForm.addNodeName = "";
    },
    //树节点过滤
    filterNode(value, data) {
      if (!value) return true;
      return data[this.defaultProps.label].indexOf(value) !== -1;
    },
    mouseover(data) {
      this.hoverTreeNode = true;
      this.activeTreeNode = data[this.treeNodeKey];
    },
    mouseout(data) {
      this.hoverTreeNode = false;
      this.activeTreeNode = data[this.treeNodeKey];
    },
    handleDragStart(node, ev) {
      console.log("drag start", node);
    },
    handleDragEnter(draggingNode, dropNode, ev) {
      console.log("tree drag enter: ", dropNode.label);
    },
    handleDragLeave(draggingNode, dropNode, ev) {
      console.log("tree drag leave: ", dropNode.label);
    },
    handleDragOver(draggingNode, dropNode, ev) {
      console.log("tree drag over: ", dropNode.label);
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      this.$emit("handleDragEnd", draggingNode, dropNode, dropType);
      console.log("tree drag end: ", dropNode && dropNode.label, dropType);
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      console.log("tree drop: ", dropNode.label, dropType);
      this.$emit("treeHandleDrop", draggingNode, dropNode, dropType, ev);
    },
    //树节点点击
    nodeClick(data, node, c) {
      console.log("树节点点击参数", data, node, c);
      this.$emit("treeNodeClick", data, node, c, this.treeName);
    },
  },
};
</script>
<style lang="scss" scoped>


.ytree {
  width: 100%;
  text-align: left;
  // padding: 5px;
  font-size: 14px;
  box-sizing: border-box;
  .iconfont,
  .eiconfont {
    cursor: pointer;
  }
}
.click_title {
  color: var(--linkColor);
}
.ytree_title-left {
  cursor: pointer;
}
.ytree_title {
  display: flex;
  justify-content: space-between;
  position: relative;
  height: 32px;
  align-items: center;
}
.ytree_title-left_name {
  font-weight: bold;
  margin-left: 5px;
}
.ytree_title-right {
  display: flex;
  .iconfont,
  .eiconfont {
    margin-left: 6px;
  }
}

.ytree_title-right-search_inputbox {
  width: 100%;
  /deep/ .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background: #fff;
  // width: 0;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  transition: 0.2s all;
}
.ytree_title-right-search_inputbox-input {
  cursor: pointer;
  width: 80%;
}
.ytree_title-right-search_inputbox-cancel {
  width: 30px;
  margin-left: 10px;
  font-size: 12px;
}
//新增、删除树的弹窗样式
.operation_popover_content {
  font-size: 14px;
  width: 100%;
  text-align: left;
  .iconfont,
  .eiconfont {
    cursor: pointer;
  }
}
.operation_popover_content-first_title,
.operation_popover_content-second_title,
.ytree_popover-second_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.operation_popover_content-first_operatelist {
  cursor: pointer;
  margin: 5px 0;
}
.operation_popover_content-first_operatelist_name {
  margin-left: 10px;
}
.operation_popover_content-second-input,
.ytree_popover-second-input {
  .el-form,
  .el-form-item,
  .el-form-item__content {
    height: 35px;
    line-height: 35px;
    margin-bottom: 10px;
  }
  // .el-input {
  //   margin-bottom: 20px;
  // }
  .el-button {
    margin-top: 15px;
    width: 100%;
  }
  text-align: center;
}
.ytree_popover-second-input_content {
  text-align: left;
  margin-bottom: 10px;
}
.el-divider {
  margin: 10px 0;
}

.ytree-draggable {
  /deep/ .el-tree-node__content:hover {
    &:before {
      content: "\e6d2";
      font-family: "iconfont";
      position: absolute;
      left: -10px;
    }
  }
}
.ytree_node {
  width: calc(100% - 30px);
  display: flex;
  justify-content: space-between;
  .ytree_node-icon {
    color: var(--linkColor);
    margin-right: 5px;
  }
  .ytree_node-left {
    display: inline-block;
    width: calc(100% - 30px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.ytree_popover-first_operate {
  cursor: pointer;
  padding: 10px 5px;
  border-radius: 4px;
  &:hover {
    background: #d5e7ff;
  }
}
.ytree_popover-first_operate_name {
  margin-left: 8px;
}
.ytree_popover {
  .iconfont,
  .eiconfont {
    cursor: pointer;
  }
}
//选中树高亮以及加粗
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  .ytree_lable {
    font-weight: bold;
  }
}
.operation_popover_content-first_check{
  .el-radio{
    margin: 5px 0;
  }
}
/deep/ .el-radio__inner{
  border-radius: 2px;
  background: none!important;
  border: none;
}
/deep/ .el-radio__input.is-checked .el-radio__inner::after{
  content: '';
  width: 10px;
  height: 5px;
  border:1px solid #606266;
  border-top: transparent;
  border-right: transparent;
  text-align: center;
  display: block;
  position: absolute;
  top: 4px;
  left: 3px;
  transform: rotate(-45deg);
  border-radius: 0;
  background: none;
}



</style>
